import { render } from "./QMiniCard.vue?vue&type=template&id=530b118a&scoped=true"
import script from "./QMiniCard.vue?vue&type=script&lang=js"
export * from "./QMiniCard.vue?vue&type=script&lang=js"

import "./QMiniCard.vue?vue&type=style&index=0&id=530b118a&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-530b118a"]])

export default __exports__